import React, { Component } from "react";
import { connect } from "react-redux";
import { CONSTANTS } from "utilities/constants";
import { FormControlLabel, Radio, RadioGroup } from "@mui/material";

import { withLocalizer } from "utilities/withLocalizer";
import * as utility from "utilities/utils";

import Markup from "./markup";
import ItineraryInfo from "../common/itineraryInfo";
import { updateCustomQuote } from "services/customQuote/customQuote.service";
import ErrorAlert from "../common/errorAlert";
import Alert from "@mui/material/Alert";
import { Icon } from "__ICON_REFERENCE__";

import "../../customize.scss";

export class CustomizeQuoteStepTwo extends Component {
    constructor(props) {
        super(props);
    }

    handleChangeMarkupCoverage = (event) => {
        let { customQuote } = this.props;
        if(customQuote?.data?.markupCoverage) {

            let newMarkupCoverage = event.target.value;
            let newMarkup = utility.getMarkupObject();

            let quoteOptions = customQuote?.data?.quoteOptions || [];
        
            const updatedQuoteOptions = quoteOptions.map((quoteOption) => ({
                ...quoteOption,
                products: quoteOption.products.map((product) => ({
                    ...product,
                    itineraries: product.itineraries?.map((itinerary) => {
                        if(itinerary?.included) {
                            return { ...itinerary, markup: newMarkup };
                        }
                        else {
                            return itinerary;
                        }
                    })
                }))
            }));

            // Update the store with new data object
            this.props.dispatch(updateCustomQuote({
                ...customQuote.data,
                markupCoverage: newMarkupCoverage,
                markup: newMarkup,
                quoteOptions: updatedQuoteOptions
            }));
        }
    };

    handleChangeMarkupType = (newMarkupType, itineraryNumber) => {
        let { customQuote } = this.props;
        if(customQuote?.data?.markupCoverage) {
            let markup = utility.getMarkupObject(newMarkupType);
            if(customQuote.data.markupCoverage === CONSTANTS.MARKUP_COVERAGE_ALL) {
                this.props.dispatch(updateCustomQuote({
                    ...customQuote.data,
                    markup
                }));
            }
            else
            {
                this.props.dispatch(updateCustomQuote({
                    ...customQuote.data,
                    quoteOptions: customQuote?.data?.quoteOptions?.map(quoteOption => ({
                        ...quoteOption,
                        products: quoteOption.products.map(product => ({
                            ...product,
                            itineraries: product.itineraries?.map(itinerary => 
                                itinerary && itinerary.itineraryNumber === itineraryNumber ?
                                    { ...itinerary, markup }
                                    : itinerary
                            )
                        }))
                    }))
                }));
            }
        }
    };

    handleChangeMarkup = (value, itineraryNumber, isAdult) => {

        let { customQuote } = this.props;
        if(customQuote?.data?.markupCoverage) {
            if(customQuote.data.markupCoverage === CONSTANTS.MARKUP_COVERAGE_ALL) {
                let updatedMarkup = { ...customQuote.data.markup };
                if(isAdult) {
                    updatedMarkup.adult = value;
                }
                else {
                    updatedMarkup.child = value;
                }
                this.props.dispatch(updateCustomQuote({
                    ...customQuote.data,
                    markup: updatedMarkup
                }));
            }
            else
            {
                this.props.dispatch(updateCustomQuote({
                    ...customQuote.data,
                    quoteOptions: customQuote?.data?.quoteOptions?.map(quoteOption => ({
                        ...quoteOption,
                        products: quoteOption.products.map(product => ({
                            ...product,
                            itineraries: product.itineraries?.map(itinerary => {
                                if(itinerary && itinerary.itineraryNumber === itineraryNumber && itinerary.markup) {
                                    let updatedMarkup = { ...itinerary.markup };
                                    if(isAdult) {
                                        updatedMarkup.adult = value;
                                    }
                                    else {
                                        updatedMarkup.child = value;
                                    }
                                    return { ...itinerary, markup: updatedMarkup };
                                }
                                else {
                                    return itinerary;
                                }
                            })
                        }))
                    }))
                }));
            }
        }
    };

    render() {
        const { data, customQuote, events, error } = this.props;
        const { currentStep } = data;
        if (currentStep !== 2) {
            return null;
        }

        let { markupCoverage } = customQuote?.data || CONSTANTS.MARKUP_COVERAGE_ALL;
        let { quoteOptions } = customQuote?.data || [];
        
        const adultOnlyQuote = this.props.isAdultOnlyQuote(quoteOptions);

        return (
            <>
                {customQuote && quoteOptions?.length > 0 ? 
                    <div className="step-editor">
                        <div className="step-heading">
                            <h4>{ this.props.localize("qma-custom-quote-step-2-heading") }</h4>
                            <div>
                                { this.props.localize("qma-custom-quote-step-2-intro") }
                            </div>
                        </div>
                        <div className="custom-quote-editor-container margin-top-4x">
                            <div className="custom-quote-editor-panel-wrapper splitter">
                                <div className="custom-quote-editor-panel">
                                    <div className="editor-tip">
                                        { this.props.localize("qma-custom-quote-markup-prefer-label") }
                                    </div>
                                    <div className="margin-top-1x">
                                        <RadioGroup
                                            row
                                            value={markupCoverage}
                                            aria-labelledby="markup-type-radio-buttons-group-label"
                                            defaultValue={CONSTANTS.MARKUP_COVERAGE_ALL}
                                            name="markup-type-radio-buttons-group"
                                            onChange={ this.handleChangeMarkupCoverage }
                                        >
                                            <FormControlLabel value={CONSTANTS.MARKUP_COVERAGE_ALL} control={<Radio />} label={ this.props.localize("qma-custom-quote-markup-all") } />
                                            <FormControlLabel value={CONSTANTS.MARKUP_COVERAGE_INDIVIDUAL} control={<Radio />} label={ this.props.localize("qma-custom-quote-markup-individual") }  />
                                        </RadioGroup>
                                    </div>
                                    <div className="row margin-top-1x">
                                        <Alert icon={<Icon name="info" className="icon-24" />} variant="outlined" severity="info" className="info-alert reversed-style">
                                            {this.props.localize("qma-markup-percent-surcharge-warning")}
                                        </Alert>
                                    </div>
                                </div>
                            </div>
                            {markupCoverage === CONSTANTS.MARKUP_COVERAGE_ALL ?
                                <div className="custom-quote-editor-panel-wrapper splitter">
                                    <div className="custom-quote-editor-panel">
                                        <Markup 
                                            data={{ 
                                                markup: customQuote?.data?.markup, 
                                                language: customQuote?.data?.languageCode,
                                                referenceId: "markup-coverage-all",
                                                adultOnly: adultOnlyQuote
                                            }}
                                            events={{
                                                handleChangeMarkupType: this.handleChangeMarkupType,
                                                handleChangeMarkup: this.handleChangeMarkup
                                            }}
                                        />
                                    </div>
                                </div>
                                :
                                quoteOptions?.map((option, optionIndex) => 
                                    option?.products?.map((product, productIndex) => 
                                        product?.itineraries?.map((itinerary, itineraryIndex) =>
                                            itinerary.included ?
                                                <div key={itineraryIndex} className="custom-quote-editor-panel-wrapper splitter"> 
                                                    <div className="custom-quote-editor-panel step-2">
                                                        <div className="d-flex">
                                                            <div className="col-itinerary-selector">
                                                                {itinerary.itineraryNumber + "."}
                                                            </div>
                                                            <div className="col-itinerary-info">
                                                                <ItineraryInfo option={option} itinerary={itinerary} product={product} />
                                                                <div className="margin-top-2x">
                                                                    <Markup 
                                                                        data={{ 
                                                                            itinerary, 
                                                                            markup: 
                                                                            itinerary?.markup,
                                                                            language: customQuote?.data?.languageCode,
                                                                            referenceId: itinerary.itineraryNumber,
                                                                            adultOnly: itinerary.adultOnly ?? false
                                                                        }}
                                                                        events={{
                                                                            handleChangeMarkupType: this.handleChangeMarkupType,
                                                                            handleChangeMarkup: this.handleChangeMarkup
                                                                        }}
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                : null
                                        )
                                    )
                                )
                            }
                        </div>
                    </div>
                    :null
                }
                {error && error.trim().length > 0 ?
                    <ErrorAlert 
                        error={error} 
                        isShowAlert={(error && error.trim().length > 0)} 
                        closeAlert={() => this.props.events && this.props.events.onAlertClose && this.props.events.onAlertClose()} 
                    />
                    : null
                }
            </>
        );
    }
}

const mapStateToProps = (state) => ({
    customQuote: state.customQuote
});

export default connect(mapStateToProps)(withLocalizer(CustomizeQuoteStepTwo));